'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_MAP = undefined;
exports.getButtonNameByStatus = getButtonNameByStatus;
exports.getStatusByScanResult = getStatusByScanResult;
exports.getAppName = getAppName;

var _lodash = require('lodash');

var STATUS_MAP = exports.STATUS_MAP = {
  INIT: 'INIT',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

/**
 * 根据扫脸状态获取按钮文案
 * 1. 未扫脸 => 人脸授权
 * 2. 扫脸成功 => 授权成功
 * 3. 扫脸失败 => 授权失败
 */
function getButtonNameByStatus(status, initBtnName) {
  switch (status) {
    case STATUS_MAP.SUCCESS:
      return '授权成功';
    case STATUS_MAP.ERROR:
      return '授权失败';
    default:
      return initBtnName || '人脸授权';
  }
}

function getStatusByScanResult(scanResult) {
  var result = void 0;

  if ((0, _lodash.isNil)(scanResult)) {
    result = STATUS_MAP.INIT;
  } else if ((0, _lodash.isEqual)(scanResult, true) || (0, _lodash.isEqual)(scanResult, 'true')) {
    result = STATUS_MAP.SUCCESS;
  } else {
    result = STATUS_MAP.ERROR;
  }
  return result;
}

function getAppName() {
  var appName = (0, _lodash.get)(window.G_GOV_MESSAGE, 'appName.value');
  if (!(0, _lodash.isNil)(appName)) {
    return appName;
  }
  return '';
}